import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  initPickupDeliveryTimes,
  availablePickupDeliveryDates,
  getNexOpenDate,
  isTimestampAfterCurrentDate,
  getCurrentDate,
  IsStoreOpenAtTime,
  getCustomDate
} from "../../../api/helpers/datetimeHelper";
import { DateTime } from "luxon";
import uuid from "uuid/v1";
import { $$ } from "./../../OO_jquery";
import { DefaultPaymentHandler } from "../../../api/payment/DefaultPaymentHandler.js";
import { getOrderHistory } from "../../../api/services/orderService.js";
import { userIsExist, storeCard } from "../../../api/services/userService";
import { logger } from "../../../api/Logger";
import { bus } from "../../../main";
import {
  CONSTANT_ORDER_TYPE_DELIVERY,
  CONSTANT_ORDER_TYPE_PICKUP,
  CONSTANT_ORDER_TYPE_DINEIN,
} from "../../../constans/strings.js";
import { orderTypeHelper } from "../../../api/helpers/orderTypeHelper";
import {StripePay} from "../../../api/payment/stripePay"
import { removeOrder, updateOrderStatus } from "../../../api/helpers/rtdbHelper";
export default {
  computed: {
    ...mapGetters([
      "user",
      "dbuser",
      "cartValue",
      "viewConfig",
      "selectedCompanyViewConfig",
      "currentstore",
      "getIsDelivery",
      "deliveryFee",
      "used_coupons",
      "getTotalPrice",
      "isGift",
      "cartItems",
      "costlyCartItems",
      "getProductOutcomeInfo",
      "applicableLoyalityRule",
      "getMenuEntity",
      "reedemptionLocalUsedPoints",
      "useStampCollection",
      "getSavedPoints",
      "deliveryAddress",
      "getDeliveryDuration",
      "selectedCompany",
      "getloadedMenu",
      "userCheckoutInfo",
      "isUpdateDeliverAddress",
      "getOrderPreparationTime",
      "getSubsidyFee",
      "getTotalPoints",
      "deliveryDuration",
      "getDeliveryPureDuration",
      "deliveryTimeSlots",
      "getDeliveryIsLoading",
      "getSelectedMenuType",
      "isDeliveryTimeSlotsEnable",
      "addressOutOfService",
      "storeSupportsLoyaltyPoints",
      "getCartType",
      "hqDoc",
      "storeMenu",
      "storeMenuWithMenuName",
      "currencySign",
      "getSurchareHolidayName",
      "getSharedCartProps",
      "showSharedCart",
    ]),
    isLoyaltyMarketingEnabled() {
      return this.userInfo && this.selectedCompany.EnableLoyaltyMarketing;
    },
    enabledMultipleMenus() {
      return this.selectedCompany
        && this.selectedCompany.ViewComponentConfigs
        && this.selectedCompany.ViewComponentConfigs.MultipleMenus == true;
    },
    showDeliveryDistance() {
      return (
        this.addressOutOfService && this.deliveryAddress.StreetAddress != ""
      );
    },
    canPayByPoints() {
      return this.payByPoint.canPay && this.storeSupportsLoyaltyPoints;
    },
    canPayByOtherThanCard() {
      return (
        this.canPayByApple ||
        this.canPayByGoogle ||
        this.isPayByCashEnable ||
        this.canPayByPoints ||
        this.canPayLater
      );
    },
    canPayLater() {
      return this.viewConfig.EatInPayLater
        && this.isEatIn;
    },
    payButtonsAreDisabled() {
      const output =
        this.proccessing ||
        this.showDeliveryDistance ||
        !this.exceedMinPurchase ||
        this.orderDisbaled ||
        this.addressOutOfService ||
        this.getDeliveryIsLoading;
      return output;
    },
    payLaterButtonIsDisabled() {
      const table = this.eatInModel.TableNumber
          || sessionStorage.getItem("table");
      return this.payButtonsAreDisabled || !table;
    },
    payLaterButtonText() {
      if(this.isEatIn) {
        return this.currentStoreDoc.PayLaterButtonTextEnabled && this.currentStoreDoc.PayLaterButtonText ? this.currentStoreDoc.PayLaterButtonText : this.$t("message.payLater");
      } else if(this.isDelivery) {
        return this.$t("message.payCashOnDelivery");
      }
    },
    getPoints() {
      if (this.storeSupportsLoyaltyPoints === true) {
        if (
          this.paymentMethod == 2 &&
          !this.getMenuEntity.IsEarnPointsWhenRedeem
        )
          return 0;
        else return this.getTotalPoints;
      } else return null;
    },
    getRedemPoints() {
      return this.paymentMethod == 2 ? this.payByPoint.cardValueInPoint : 0;
    },
    payByPoint() {
      let pointsValue = 0;
      if(this.userInfo && this.getMenuEntity.PointsToDollarRatio > 0) {
        pointsValue = this.userInfo.RewardPoints / this.getMenuEntity.PointsToDollarRatio;
      }
      var res = {
        pointsValue,
        canPay: pointsValue >= this.getTotalPrice,
        cardValueInPoint:
          this.getMenuEntity.PointsToDollarRatio * this.getTotalPrice,
      };
      return res;
    },
    orderType() {
      if (this.isDelivery) {
        return 10;
      } else if (this.isChargeToRoom) {
        return 10;
      } else if (this.isEatIn) {
        if (this.paymentMethod === 8)
          return 8
        else
          return 2;
      } else {
        return 3;
      }
    },
    holder() {
      var firstName =
        this.detailModel.FirstName ||
        this.roomDeliveryModel.FirstName ||
        this.eatInModel.FirstName ||
        "";
      var lastName =
        this.detailModel.LastName ||
        this.roomDeliveryModel.LastName ||
        this.eatInModel.LastName ||
        "";
      return firstName.trim() + " " + lastName.trim();
    },
    showPayment() {
      return this.paymentMethod == 1;
    },
    ChargeToRoomRadioValue() {
      if (
        !this.viewConfig.ChargeToRoomRadio &&
        this.paymentMethod == 0 &&
        !this.$route.query.result
      )
        this.paymentMethod = 1;
      return this.viewConfig.ChargeToRoomRadio;
    },
    isPayByCashEnable() {
      return this.isPickup && this.viewConfig.EnableCashOnPickup;
    },
    orderDisbaled() {
      if (
        this.selectedCompany.Delivery ||
        this.selectedCompany.EatIn ||
        this.selectedCompany.PickUp
      ) {
        if (this.cartItems.filter((p) => !p.disable).length == 0) return true;
        return (
          this.proccessing ||
          this.costlyCartItems.length == 0 ||
          (!this.selectedDeliveryTime && !this.selectedPickupTime) ||
          !this.selectedCompany.IsInOperation ||
          !this.exceedMinPurchase
        );
      } else {
        return true;
      }
    },
    isPreOrder() {
      if (!this.deliveryDate) {
        return false;
      }
      var date = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      var deliveryDate = DateTime.fromISO(
        DateTime.fromJSDate(this.deliveryDate).toISODate()
      );
      if (date.day != deliveryDate.day) {
        return true;
      }
      return false;
    },
    minPurchase() {
      var result = 0;
      if (this.selectedCompany.OrderTypeConstraintRules) {
        result = this.selectedCompany.OrderTypeConstraintRules[this.orderType]
          ? this.selectedCompany.OrderTypeConstraintRules[this.orderType]
            .MinimumTotalPrice
          : 0;
      }
      return result;
    },
    exceedMinPurchase() {
      return this.cartValue >= this.minPurchase;
    },
    isCheckoutValidate() {
      var update =
        this.detailModel.FirstName +
        this.detailModel.LastName +
        this.detailModel.Email +
        this.detailModel.Phone +
        this.deliveryAddressModel.StreetAddress +
        this.deliveryAddressModel.PostalCode +
        this.deliveryAddressModel.State +
        this.deliveryAddressModel.CityTown +
        this.eatInModel.TableNumber +
        this.eatInModel.FirstName +
        this.eatInModel.LastName +
        this.payButtonsAreDisabled +
        this.selectedPickupTime +
        this.selectedDeliveryTime +
        this.paymentModel.CardHolder +
        this.paymentModel.CardNumber +
        this.paymentModel.ExpireDate +
        this.paymentModel.CVV;

      if (
        (this.isDelivery && !this.deliveryAddressModel.CityTown) ||
        (this.isEatIn && !this.eatInModel.TableNumber)
      ) {
        return false;
      }

      let cms = [];
      if (
        !this.selectedCompany.ChargeToRoom &&
        !this.isEatIn &&
        this.$refs.myDetails
      ) {
        let p1 = this.$refs.myDetails.validate();
        cms.push(p1);
      }

      if (this.isDelivery && this.$refs.deliveryAddress) {
        let p3 = this.$refs.deliveryAddress.validate();
        cms.push(p3);
      }
      if (this.isEatIn + this.$refs.eatIn) {
        let p4 = this.$refs.eatIn.validate();
        cms.push(p4);
      }

      var that = this;
      if (
        (this.getTotalPrice == 0 &&
          ((!this.selectedCompany.ChargeToRoom &&
            !this.isEatIn &&
            this.detailModel.FirstName != "") ||
            (this.isEatIn && this.eatInModel.FirstName != ""))) ||
          update
          ? false
          : false
      )
        cms = [];

      Promise.all(cms).then(async (values) => {
        if (
          !values.every((v) => v) ||
          (that.isDelivery &&
            that.$refs.deliveryAddress &&
            (!that.$refs.deliveryAddress.isDeliveryAreaValid ||
              !that.$refs.deliveryAddress.isDeliveryAddressValid)) ||
          (that.isDelivery && that.addressOutOfService) ||
          this.orderDisbaled
        ) {
          if (this.$refs && this.$refs.stripePayRef) {
            this.$refs.stripePayRef.disabled = true;
          }
          return false;
        } else {
          if (this.$refs && this.$refs.stripePayRef) {
            this.$refs.stripePayRef.disabled = this.payButtonsAreDisabled;
          }
          return !this.payButtonsAreDisabled;
        }
      });
    },
    getSelectedOrderTypeName() {
      if(this.isDelivery)
        return "Delivery";
      else if(this.isPickup)
        return "Pickup";
      else
        return "Dine In";
    }
  },
  async mounted(isDesktop, checkoutObj) {
    this.handleScroll = this.handleScroll.bind(checkoutObj);
    window.addEventListener("scroll", this.handleScroll);

    checkoutObj.orderIdentifier = uuid();
    checkoutObj.guestUserIdentifier = uuid();
    checkoutObj.checkStoreClosed();
    checkoutObj.updateShoppingCartItems();
    checkoutObj.setShowDeliveryFee(true);
    checkoutObj.updateTimeList();
    checkoutObj.checkGoogleLoaded();
    if (!checkoutObj) {
      return;
    }
    try {
      checkoutObj.userInfo = checkoutObj.dbuser;
      if (!checkoutObj.userInfo) checkoutObj.userInfo = {};
      checkoutObj.initModel();

      checkoutObj.computeRules();

      var scheduledTime = orderTypeHelper.getDeliveryTime();
      if (scheduledTime) {
        let scheduledTimeDT = getCustomDate(
          new Date(scheduledTime),
          checkoutObj.selectedCompany.TimezoneIanaFormat
        );
        var now = getCurrentDate(
          checkoutObj.selectedCompany.TimezoneIanaFormat
        );
        if (scheduledTimeDT < now) scheduledTime = null;
      }
      checkoutObj.setPickupDeliveryDates(scheduledTime);
      checkoutObj.setDeliveryTimes(checkoutObj.deliveryDate, true, false, scheduledTime);
      checkoutObj.setPickupTimes(checkoutObj.pickupDate, false , scheduledTime);

      if (localStorage.getItem("checkoutData")) {
        var initialState = function () {
          return JSON.parse(localStorage.getItem("checkoutData"));
        };
        Object.assign(checkoutObj.$data, initialState());
        checkoutObj.showBecomeMember = false;
        checkoutObj.pickupDate = new Date(checkoutObj.pickupDate);
        checkoutObj.deliveryDate = new Date(checkoutObj.deliveryDate);
      }
      if (checkoutObj.$route.query.result) {
        if (
          checkoutObj.$route.query.result === "SUCCESS" &&
          checkoutObj.$route.query.merchant_trade_no
        ) {
          localStorage.removeItem("checkoutData");
          checkoutObj.processPayment(
            checkoutObj.$route.query.merchant_trade_no,
            checkoutObj.guestUserId
          );
        } else {
          checkoutObj.error = checkoutObj.$route.query.trade_status;
        }
      }
      if (checkoutObj.orderid) {
        checkoutObj.setStore(checkoutObj.storeid);
        checkoutObj.initStore({
          storeId: checkoutObj.storeid,
          callback: () => {
            checkoutObj.setStoreLoaded();
          }
        });
        await checkoutObj.getStoreMenu(checkoutObj.storeid);
        var that = checkoutObj;
        let odata = localStorage.getItem(checkoutObj.storeid + "-OrdersDatas");
        let OrdersData = odata != null ? JSON.parse(odata) : [];

        let savedorder = OrdersData.find(function (x) {
          return x.UDID == checkoutObj.orderid;
        });
        if (savedorder) {
          that.clearAllOrders();
          that.SetOrder(savedorder, checkoutObj);
          checkoutObj.updateShoppingCartItems();
          checkoutObj.computeRules();
          if (savedorder.OrderItems.length > checkoutObj.cartItems.length) {
            checkoutObj.showReorderMissingMessage = true;
          }
        } else {
          getOrderHistory(checkoutObj.user.id, checkoutObj.orderid)
            .get()
            .then((result) => {
              if (result.exists) {
                result = result.data();
                that.clearAllOrders();
                that.SetOrder(result, checkoutObj);
                checkoutObj.updateShoppingCartItems();
                checkoutObj.computeRules();
                if (savedorder.OrderItems.length > checkoutObj.cartItems.length) {
                  checkoutObj.showReorderMissingMessage = true;
                }
              }
            });
        }
      }else{
        checkoutObj.setStoreLoaded();
      }
    } catch (exception) {
      logger.log(exception.name, exception.message, "", logger.LogType.Error);
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let room = to.query.room | localStorage.getItem("room");
      if (room) {
        vm.$data.roomDeliveryModel.RoomNumber = room;
      }
      let table = to.query.table || sessionStorage.getItem("table");
      if (table) {
        vm.$data.eatInModel.TableNumber = table;
        let securityCode = to.query.s || sessionStorage.getItem("securityCode");
        if (securityCode) {
          vm.$data.eatInModel.SecurityCode = securityCode;
        }
      }
    });
  },
  methods: {
    ...mapActions([
      "initStore",
      "getStoreMenu",
      "clearCart",
      "signUserUp",
      "signUserIn",
      "applyPriceTriggers",
      "clearCardType",
      "applyDeliveryAddress",
      "storeCartInStorage",
      "updateShoppingCartItems",
      "resetUser",
    ]),
    ...mapMutations([
      "setStore",
      "setStoreLoaded",
      "setIsDelivery",
      "setIsPickup",
      "REMOVE_CART_ITEM",
      "Add_ProductItem",
      "setSurchargeTime",
      "setCardNumber",
      "add_user_checkout_info",
      "setShowDeliveryFee",
      "setDeliveryTime",
      "setPickupTime",
      "setScheduledDeliveryTime",
      "setSelectedMenuType",
      "RemoveCartItemsFromRepository",
    ]),
    payLaterClickHandler() {

      if(this.isEatIn) {
        this.setMethodAndPlaceOrder(8);
      } else if(this.isDelivery) {
        this.setMethodAndPlaceOrder(9);
      }
    },
    hidePaymentIndicator() {
      this.showPaymentIndicator = false;
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    },
    updateProcessing(status) {
      this.proccessing = status;
    },
    remountStripeButton() {
      const canPayByApple = this.canPayByApple;
      const canPayByGoogle = this.canPayByGoogle;

      this.canPayByApple = false;
      this.canPayByGoogle = false;

      this.$nextTick(() => {
        this.canPayByApple = canPayByApple;
        this.canPayByGoogle = canPayByGoogle;
      });
    },
    async setMethodAndPlaceOrder(paymentMethod) {
      const stripe = this.$stripe;
      const cardElement = this.$refs.payment && this.$refs.payment.$refs.cardInfo ? this.$refs.payment.$refs.cardInfo.getCardElement() : "";
      setTimeout(() => {
        this.setPaymentMethod(paymentMethod);
        if (paymentMethod == 8) {
          this.placingPayLaterOrder = true;
        } else {
          this.placingPayLaterOrder = false;
        }
        setTimeout(() => {
          this.placeOrder(stripe, cardElement);
        }, 20);
      }, 20);
    },
    checkStoreClosed() {
      var now = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);

      if (
        !this.selectedCompany.EnablePreoderForPickup &&
        !this.selectedCompany.EnablePreoderForDelivery
      )
        now = now.plus({ minutes: this.selectedCompany.OrderPreparationTime });

      if (
        (!IsStoreOpenAtTime(
          this.selectedCompany.BlackoutDates,
          this.selectedCompany.OperatingHours,
          this.selectedCompany.IsInOperation,
          now
        ) &&
          !this.selectedCompany.EnablePreoderForDelivery &&
          !this.selectedCompany.EnablePreoderForPickup) ||
        !this.selectedCompany.IsInOperation
      ) {
        this.$router.push({
          name: "store",
          params: { storeid: this.storeid },
        });
      }
    },
    SetOrder(order, ins) {
      var that = ins;
      order.OrderItems.forEach((orderitem, orderItemIndex) => {
        var product = that.getProductOutcomeInfo(orderitem.Product_ID);
        if (product && product.Status != 3) {
          var modifiers = orderitem.OrderExtras.map((m, orderExtraIndex) => {
            var result = {
              quantity: m.Quantity,
              TaxRate: m.UsingUnitPrice > 0 ? m.FinalTax / m.UsingUnitPrice : 0,
              Price: m.UsingUnitPrice,
              ID: m.Extra_ID,
              Name: m.Name,
              DisplayingOrder: orderExtraIndex + 1,
            };
            if (m.ChildrenOrderExtras)
              result.selectedSubmodifiers = m.ChildrenOrderExtras.map((m2, childernOrderIndex) => {
                return {
                  quantity: m2.Quantity,
                  TaxRate:
                    m2.UsingUnitPrice > 0 ? m2.FinalTax / m2.UsingUnitPrice : 0,
                  Price: m2.UsingUnitPrice,
                  ID: m2.Extra_ID,
                  Name: m2.Name,
                  DisplayingOrder: childernOrderIndex + 1,
                };
              });
            return result;
          });
          that.Add_ProductItem({
            item: {
              id: orderitem.Product_ID,
              uniqueId: uuid(),
              code: product.ProductCode,
              name: product.Name,
              description: product.ShortDescription,
              photoUrl: product.PhotoUrl,
              tax: product.TaxRate,
              price: orderitem.UsingUnitPrice,
              categoryId: orderitem.CategoryId,
              categoryName: orderitem.CategoryName,
              displayingOrder: orderItemIndex + 1,
            },
            ProductCategoryIDs: product.ProductCategoryIDs,
            ProductTagIDs: product.ProductTagIDs,
            quantity: orderitem.Quantity,
            PreparationTime: product.PreparationTime,
            modifiers: modifiers,
            sharedcart: this.showSharedCart,
            user: this.getSharedCartProps.user,
            table: this.getSharedCartProps.table,
            storeId: this.currentStoreDoc.ID
          });
        }
      });
      that.applyPriceTriggers();
      switch (order.OrderType) {
        case 10:
          that.deliveryMode();
          that.deliveryAddressModel.StreetAddress =
            order.DeliveryAddress.Address;
          that.deliveryAddressModel.Latitude = order.DeliveryAddress.Latitude;
          that.deliveryAddressModel.Longitude = order.DeliveryAddress.Longitude;
          that.deliveryAddressModel.PostalCode = order.DeliveryAddress.Postcode;
          that.deliveryAddressModel.State = order.DeliveryAddress.State;
          that.deliveryAddressModel.CityTown = order.DeliveryAddress.Suburb;
          that.applyDeliveryAddress({
            address: {
              ...that.deliveryAddressModel,
            },
            scheduledTime: new Date(that.selectedDeliveryTime).toISOString(),
            isUpdateDeliverAddress: true,
          });
          break;
        case 2:
          that.eatInMode();
          if (order.Tables && order.Tables[0] && order.Tables[0].Name)
            that.eatInModel.TableNumber = order.Tables[0].Name;
          break;
        case 3:
          that.pickupMode();
          break;
      }
    },
    updateTimeList() {
      var that = this;
      setTimeout(() => {
        if (that.$route.fullPath.indexOf("checkout") > 0) {
          let selectedPickupTimeIndex = that.pickupTimes.indexOf(
            that.pickupTimes.find((p) => p.time == that.selectedPickupTime)
          );
          if (
            !that.selectedCompany.EnableThirdPartyDelivery ||
            !that.selectedCompany.EnableThirdPartyDelivery.DoorDash
          ) {
            let selectedDeliveryTimeIndex = that.dtimes.indexOf(
              that.dtimes.find((p) => p.time == that.selectedDeliveryTime)
            );
            that.setDeliveryTimes(that.deliveryDate, true, false, null );
            if (
              selectedDeliveryTimeIndex >= 0 &&
              that.dtimes &&
              that.dtimes.length > 0
            ) {
              selectedDeliveryTimeIndex =
                that.dtimes.length > selectedDeliveryTimeIndex
                  ? selectedDeliveryTimeIndex
                  : that.dtimes.length - 1;
              that.selectedDeliveryTime =
                that.dtimes[selectedDeliveryTimeIndex].time;
            }
          }
          that.setPickupTimes(that.pickupDate, false, null);
          if (
            selectedPickupTimeIndex >= 0 &&
            that.dtimes &&
            that.dtimes.length > 0
          ) {
            selectedPickupTimeIndex =
              that.pickupTimes.length > selectedPickupTimeIndex
                ? selectedPickupTimeIndex
                : that.pickupTimes.length - 1;
            that.selectedPickupTime =
              that.pickupTimes[selectedPickupTimeIndex].time;
          }
          that.updateTimeList();
        }
      }, 1 * 60000);
    },
    SelecteDPTime() {
      return this.isDelivery
        ? !this.selectedDeliveryTime
        : !this.selectedPickupTime;
    },
    btnStyle(isPrimary, isMobile) {
      var style = [];
      if (isPrimary) {
        if (isMobile) style.push(this.mobileStyles.btn);
        else style.push(this.desktopStyles.btn);
      }
      return style;
    },
    acceptTermsStyle() {
      var style = [];
      if (this.turnAcceptLabelToRed) {
        style.push({ color: "#ff0000" });
      }
      return style;
    },
    showTermsAndCondition() {
      bus.$emit("showTermsAndCondition", true);
    },
    saveCredit() {
      this.saveCard = true;
    },
    saveUser(val) {
      this.registerNew = val;
    },
    setRoomNoFromStorage() {
      var roomNo = localStorage.getItem("room");
      if (roomNo) {
        this.roomDeliveryModel.RoomNumber = roomNo;
      }
    },
    showChargeToRoom() {
      return (
        this.payByPoint.canPay ||
        this.isPayByCashEnable ||
        this.viewConfig.EnableAlipayPayment ||
        this.viewConfig.EnableWechatPayment ||
        this.viewConfig.EnableApplePayment ||
        this.viewConfig.EnableGooglePayment
      );
    },
    showPickupAddress() {
      return (
        this.isPickup &&
        !this.pickupDisabled &&
        !this.viewConfig.HideAddressOnPickup
      );
    },
    showGettingYourMealMessage() {
      return !(
        !this.selectedCompanyViewConfig.Delivery &&
        !this.selectedCompanyViewConfig.PickUp &&
        !this.selectedCompanyViewConfig.DeliverToRoom &&
        !this.selectedCompanyViewConfig.EatIn
      );
    },
    deliveryMode() {
      if (
        this.enabledMultipleMenus
          && this.storeMenu
          && !orderTypeHelper.isDelivery()
      ) {
        this.newOrderType = CONSTANT_ORDER_TYPE_DELIVERY;
        this.showClearCartModal = true;
        this.setLastOrderTypeSelected();
        this.setNextOrderType(CONSTANT_ORDER_TYPE_DELIVERY);
      } else {
        orderTypeHelper.setOrderTypeDelivery();
        this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DELIVERY);
      }
      this.setToDelivery();
    },
    setToDelivery() {
      this.setIsDelivery(true);
      this.setIsPickup(false);
      this.isDelivery = true;
      this.isPickup = false;
      this.isChargeToRoom = false;
      this.isEatIn = false;
      this.deliverySurcharge();
      if (!this.isMobile() && this.$refs.shoppingCart)
        this.$refs.shoppingCart.SelecteDPTime(this.selectedDeliveryTime);
    },
    pickupMode() {
      if (this.enabledMultipleMenus && !orderTypeHelper.isPickup()) {
        this.newOrderType = CONSTANT_ORDER_TYPE_PICKUP;
        this.showClearCartModal = true;
        this.setLastOrderTypeSelected();
        this.setNextOrderType(CONSTANT_ORDER_TYPE_PICKUP);
      } else {
        orderTypeHelper.setOrderTypePickup();
        this.setSelectedMenuType(CONSTANT_ORDER_TYPE_PICKUP);
      }
      this.setToPickUp();
    },
    setToPickUp() {
      this.setIsDelivery(false);
      this.setIsPickup(true);
      this.isDelivery = false;
      this.isPickup = true;
      this.isChargeToRoom = false;
      this.isEatIn = false;
      this.pickupSurcharge();
      if (!this.isMobile() && this.$refs.shoppingCart)
        this.$refs.shoppingCart.SelecteDPTime(this.selectedPickupTime);
    },
    chargeToRoomMode() {
      this.setIsDelivery(false);
      this.isDelivery = false;
      this.isPickup = false;
      this.isChargeToRoom = true;
      this.isEatIn = false;
      this.setSurchargeTime(null);
    },
    eatInMode() {
      if (this.enabledMultipleMenus && !orderTypeHelper.isDineIn()) {
        this.newOrderType = CONSTANT_ORDER_TYPE_DINEIN;
        this.showClearCartModal = true;
        this.setLastOrderTypeSelected();
        this.setNextOrderType(CONSTANT_ORDER_TYPE_DINEIN);
      } else {
        orderTypeHelper.setOrderTypeDineIn();
        this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DINEIN);
      }
      this.setToEatIn();
    },
    setToEatIn() {
      this.setIsDelivery(false);
      this.setIsPickup(false);
      this.isDelivery = false;
      this.isPickup = false;
      this.isChargeToRoom = false;
      this.isEatIn = true;
      this.setSurchargeTime(null);
    },
    setLastOrderTypeSelected() {
      if(this.isDelivery)
      {
        this.lastOrderTypeSelected = "Delivery"
      }
      else if(this.isPickup)
      {
        this.lastOrderTypeSelected = "PickUp"
      }
      else if(this.isEatIn)
      {
        this.lastOrderTypeSelected = "EatIn"
      }
    },
    setNextOrderType(value) {
      this.nextOrderType = value;
    },
    confirmClearCart(){
      this.clearAllOrders();
      orderTypeHelper.setSkipFirstStep(true);
      orderTypeHelper.setOrderType(this.nextOrderType);
      this.setSelectedMenuType(this.nextOrderType);

      this.$router.push({
        name: "store",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename,
        },
      });
    },
    cancelClearCart() {
      switch(this.lastOrderTypeSelected)
      {
        case "Delivery":
          this.setToDelivery();
          break;
        case "PickUp":
          this.setToPickUp();
          break;
        case "EatIn":
          this.setToEatIn();
          break;
      }
    },
    setPaymentMethod(value) {
      this.paymentMethod = value;
    },
    deliverySurcharge() {
      if (
        this.selectedCompany.EnablePreoderForDelivery &&
        this.deliveryDate &&
        this.selectedDeliveryTime &&
        !localStorage.table
      ) {
        this.setSurchargeTime(this.selectedDeliveryTime.toISODate());
      } else {
        this.setSurchargeTime(null);
      }
    },
    pickupSurcharge() {
      if (this.pickupDate && this.selectedPickupTime && !localStorage.table) {
        this.setSurchargeTime(this.selectedPickupTime.toISODate());
      } else {
        this.setSurchargeTime(null);
      }
    },
    setBecomeMemberResult(state) {
      this.registerNew = state;
      if (this.$refs.myDetails)
        this.$refs.myDetails.setRegisterNewUserState(state);
      if (this.$refs.eatIn) this.$refs.eatIn.setRegisterNewUserState(state);
      if (this.$refs.becomeMember) this.$refs.becomeMember.closeModal();
      this.becomeMemberShown = true;
      if (
        this.$route.query.result === "SUCCESS" &&
        this.$route.query.merchant_trade_no
      ) {
        this.processPayment(
          this.$route.query.merchant_trade_no,
          this.guestUserId
        );
      } else if (
        this.hqDoc &&
        this.hqDoc.IsSushiHub &&
        this.AcceptTermsAndCondition
      ) {
        this.placeOrder();
      }
    },
    ValidateOrder() {
      if(this.isDelivery && !this.isPickup && !this.isEatIn)
      {
        return this.isEnableTab('delivery');
      }
      else if(this.isPickup && !this.isDelivery && !this.isEatIn)
      {
        return this.isEnableTab('pickUp');
      }
      else if(this.isEatIn && !this.isDelivery && !this.isPickup)
      {
        return this.isEnableTab('dineIn');
      }else
      {
        return false;
      }
    },
    async placeOrder(stripe, cardElement) {
      if(!this.ValidateOrder())
      {
        this.error = this.$t("message.InvalidOrderType");
        return;
      }
      if (
        this.isDelivery &&
        (!this.deliveryAddressModel.StreetAddress ||
          this.deliveryAddressModel.StreetAddress == "")
      ) {
        this.$refs.deliveryAddress.isDeliveryAddressValid = false;
        this.$refs.deliveryAddress.$refs.gAutoComplete.focus();
      } else {
        if (this.$refs.deliveryAddress)
          this.$refs.deliveryAddress.isDeliveryAddressValid = true;
      }
      if (
        (this.isDelivery &&
          !isTimestampAfterCurrentDate(
            this.selectedDeliveryTime,
            this.selectedCompany.TimezoneIanaFormat
          )) ||
        (this.isPickup &&
          !isTimestampAfterCurrentDate(
            this.selectedPickupTime,
            this.selectedCompany.TimezoneIanaFormat
          ))
      ) {
        this.error = this.$t("message.InvalidDeliveryTime");
        this.disableStripeBtn = true;
        if (this.paymentMethod == 6 || this.paymentMethod == 7) {
          // this.paymentMethod = 1;
          this.PaymenttypeRender += 1;
        }
        return;
      }
      let cms = [];
      if (!this.selectedCompany.ChargeToRoom && !this.isEatIn) {
        let p1 = this.$refs.myDetails.validate();
        cms.push(p1);
      }

      if (this.selectedCompany.ChargeToRoom) {
        if (!this.isEatIn) {
          let p4 = this.$refs.roomDelivery.validate();
          cms.push(p4);
        }
        if (this.paymentMethod == 1 && this.getTotalPrice > 0) {
          let p2 = this.$refs.payment.validate();
          cms.push(p2);
          let p22 = this.$refs.payment.cardInfoValidate();
          if (p22) cms.push(p22);
        }
      } else {
        if (this.paymentMethod == 1 && this.getTotalPrice > 0) {
          let p2 = this.$refs.payment.validate();
          cms.push(p2);
          let p22 = this.$refs.payment.cardInfoValidate();
          if (p22) cms.push(p22);
        }
      }
      if (this.isDelivery && this.$refs.deliveryAddress) {
        let p3 = this.$refs.deliveryAddress.validate();
        cms.push(p3);
      }
      if (this.isEatIn) {
        let p4 = this.$refs.eatIn.validate();
        cms.push(p4);
      }

      var that = this;
      if (
        this.getTotalPrice == 0 &&
        ((!this.selectedCompany.ChargeToRoom &&
          !this.isEatIn &&
          this.detailModel.FirstName != "") ||
          (this.isEatIn && this.eatInModel.FirstName != ""))
      )
        cms = [];

      Promise.all(cms).then(async (values) => {
        if (
          values.every((v) => v) &&
          (!that.isDelivery ||
            (that.$refs.deliveryAddress &&
              that.$refs.deliveryAddress.isDeliveryAreaValid &&
              that.$refs.deliveryAddress.isDeliveryAddressValid)) &&
          !that.addressOutOfService &&
          (!that.getDeliveryIsLoading ||
            that.paymentMethod == 6 ||
            that.paymentMethod == 7) &&
          !this.orderDisbaled &&
          ((this.hqDoc &&
            this.hqDoc.IsSushiHub &&
            this.AcceptTermsAndCondition) ||
            !this.hqDoc ||
            !this.hqDoc.IsSushiHub)
        ) {
          that.error = "";
          // this.proccessing = true;
          // this.showPaymentIndicator = true;
          that.disableStripeBtn = false;
          userIsExist(that.detailModel.Email)
            .then((result) => {
              that.userIsExist = result.length > 0;
            })
            .catch(() => { });
          if (that.paymentMethod === 4 || that.paymentMethod === 5) {
            var udid = uuid();
            var guestUserId = uuid();
            that.guestUserId = guestUserId;
            localStorage.setItem("checkoutData", JSON.stringify(that.$data));

            let payment = new DefaultPaymentHandler();
            that.proccessing = true;
            that.showPaymentIndicator = true;
            payment
              .PreparePaymentUrl({
                PaymentType: that.paymentMethod === 4 ? 0 : 1,
                storeId: that.storeid,
                orderId: udid,
                userId: that.user ? that.user.id : guestUserId,
                totalAmount: that.getTotalPrice,
                storename: that.$route.params.storename,
                isMobile: that.isMobile(),
              })
              .then((result) => {
                window.location.href = result.data;
              })
              .catch((error) => {
                that.paymentSucceeded = false;
                that.proccessing = false;
                that.showPaymentIndicator = true;
                that.error = error.message;
              });
          } else {
            await that.processPayment("", "", stripe, cardElement);
          }
        } else {
          that.disableStripeBtn = true;
          if (that.paymentMethod == 6 || that.paymentMethod == 7) {
            if (
              (!that.isDelivery ||
                (that.$refs.deliveryAddress &&
                  that.$refs.deliveryAddress.isDeliveryAreaValid &&
                  that.$refs.deliveryAddress.isDeliveryAddressValid)) &&
              !that.addressOutOfService &&
              !that.orderDisbaled &&
              that.getDeliveryIsLoading
            ) {
              that.error = "";
            }
          }

          if (
            that.hqDoc &&
            that.hqDoc.IsSushiHub &&
            !that.AcceptTermsAndCondition
          ) {
            that.turnAcceptLabelToRed = true;
            setTimeout(() => {
              that.turnAcceptLabelToRed = false;
            }, 1000);
            var el = that.$el.getElementsByClassName("acceptTerms")[0];
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }

          setTimeout(() => {
            $$(that.$el)
              .find("[aria-invalid=true]")
              .focus();
          }, 10);
        }
      });
    },
    CheckIs3ds() {
      // let SecureMinimumSpend = this.selectedCompany["3DSecureMinimumSpend"];
      // if(SecureMinimumSpend && SecureMinimumSpend != 0)
      // {
      //   return this.getTotalPrice >= SecureMinimumSpend ? true : false;
      // }else
      // {
      //   return false;
      // }
      return false;
    },
    async processPayment(savedUdid, savedGuestUserId, stripe, cardElement) {
      if (
        !this.becomeMemberShown &&
        this.viewConfig.LogIn &&
        !this.user &&
        !this.registerNew &&
        !this.userIsExist &&
        !savedUdid
      ) {
        this.showBecomeMember = true;
        if (this.isMobile()) {
          window.scrollTo(0, 0);
        }
        return;
      } else {
        setTimeout(() => {
          window.scrollTo(window.scrollX, this.$data.windowScrollY);
        }, 0);
        this.showBecomeMember = false;
      }
      if (this.user) this.registerNew = false;
      this.proccessing = true;
      this.showPaymentIndicator = true;
      this.error = false;
      let payment = new DefaultPaymentHandler();
      //
      let udid = savedUdid || this.orderIdentifier;
      let scheduledTime = this.isDelivery
        ? this.selectedDeliveryTime
        : this.selectedPickupTime;
      //generate token and save in db
      let userModel = this.createUserModel();
      this.add_user_checkout_info(userModel);
      userModel.CreateUserForGuest = this.registerNew && !this.userIsExist;
      userModel.JoinOurMail = this.JoinOurMail;
      let cardModel = this.createCardModel();
      let guestUserId = savedGuestUserId || this.guestUserIdentifier;
      if (this.saveCard && this.paymentMethod != 8) {
        this.StoreCard(cardModel);
      }
      if (!this.isChargeToRoom) {
        this.roomDeliveryModel.RoomNumber = "";
      }
      if (!this.isEatIn) {
        this.eatInModel.TableNumber = "";
        this.eatInModel.SecurityCode = "";
      }
      let orderInfo = {
        subsidyFee: this.getSubsidyFee,
        orderType: this.orderType,
        notes: this.notes,
        scheduledTime: scheduledTime && !this.placingPayLaterOrder
          ? scheduledTime.toJSDate().toUTCString()
          : null,
        roomNumber: this.roomDeliveryModel.RoomNumber,
        tableNumber: this.eatInModel.TableNumber,
        securityCode: this.eatInModel.SecurityCode,
          DeliveryInstructions: this.isDelivery
            ? this.deliveryAddressModel.DeliveryInstructions
            : "",
        isPayLater: this.placingPayLaterOrder,
      };
      if (this.isDelivery) {
        orderInfo.OrderDeliveryTime = this.getDeliveryPureDuration;
        Object.defineProperty(orderInfo, "DeliveryAddress", {
          value: {
            Address: this.deliveryAddressModel.StreetAddress,
            Postcode: this.deliveryAddressModel.PostalCode,
            Suburb: this.deliveryAddressModel.CityTown,
            State: this.deliveryAddressModel.State,
            Longitude: this.deliveryAddressModel.Longitude,
            Latitude: this.deliveryAddressModel.Latitude,
          },
          enumerable: true,
        });
      }
      if (this.paymentMethod == 6 || this.paymentMethod == 7) {
        this.proccessing = false;
        this.showPaymentIndicator = false;
        var trackingOrder = payment.MakePaymentBody(
          udid,
          cardModel,
          userModel,
          this.selectedCompany,
          orderInfo,
          guestUserId,
          this.paymentMethod,
          false,
          this.used_coupons,
          {
            RewardPoints: this.getPoints,
            RedeemPoints: this.getRedemPoints,
          },
          savedUdid ? true : false,
          this.stripeToken
        );
        this.$refs.stripePayRef.setTrackingOrder(trackingOrder);
        this.$refs.stripePayRef.showPayment();

        return;
      }
      this.setBeforeunload();
      logger.log(
        "Action PlaceOrder in Checkout",
        "PlaceOrder Button is pressed",
        "/Checkout",
        logger.LogType.Info
      );
      let orderObj = this.getOrderObject(savedUdid, savedGuestUserId);
      let stripePay = new StripePay();
      let isStripeActive = this.selectedCompany.StripeActivated
      let is3ds = false;
      if (
        this.paymentMethod != 8
          && this.paymentMethod != 2
          && isStripeActive
      ) {
        is3ds = this.CheckIs3ds();
      }
      this.showPaymentIndicator = true;
      orderObj.TrackingOrder.UDID = udid;
      let res = null;
      try {
        if (is3ds) {
          res = await stripePay.createOrder(orderObj);
        } else {
          const isSavedCard = this.paymentMethod === 20;
          payment
            .MakePayment(
              udid,
              cardModel,
              userModel,
              this.selectedCompany,
              orderInfo,
              guestUserId,
              this.paymentMethod,
              false,
              this.used_coupons,
              {
                RewardPoints: this.getPoints,
                RedeemPoints: this.getRedemPoints,
              },
              stripe,
              cardElement,
              this.customerID,
              isSavedCard,
              savedUdid ? true : false,
              this.stripeToken
            )
            .then((res) => {
              this.clearBeforeunload();

              this.showPaymentIndicator = true;
              if (res.data.Success === true) {
                this.paymentSucceeded = true;
                this.proccessing = false;
                setTimeout(async () => {
                  this.showPaymentIndicator = false;
                  var trackingOrder = payment.MakePaymentBody(
                    udid,
                    cardModel,
                    userModel,
                    this.selectedCompany,
                    orderInfo,
                    guestUserId,
                    this.paymentMethod,
                    false,
                    this.used_coupons,
                    {
                      RewardPoints: this.getPoints,
                      RedeemPoints: this.getRedemPoints,
                    },
                    savedUdid ? true : false,
                    this.stripeToken
                  );

                  this.SaveCoockie(trackingOrder);

                  this.storeCartInStorage();
                  // delete order from RTDB
                  const { table } = this.getSharedCartProps;
                  await updateOrderStatus(table, this.storeid, { status: 'complete' });
                  await removeOrder(this.storeid, table);
                  this.clearCart();
                  // reset user
                  this.resetUser();
                  this.RemoveCartItemsFromRepository({
                    storeId: this.currentstore,
                  });
                  localStorage.removeItem("checkoutData");
                  this.error = "";
                  this.clearRoomAndTable();
                  if (!userModel.IsGuest)
                    this.navigateSuccess(
                      udid,
                      userModel.ID,
                      false,
                      userModel.CreateUserForGuest,
                      savedUdid
                    );
                  else {
                    if (userModel.IsGuest && userModel.CreateUserForGuest) {
                      storeCard(res.data.customerID, cardModel).then(() => {
                        this.signUserIn({
                          email: userModel.Email,
                          password: guestUserId,
                        }).then(() => {
                          this.navigateSuccess(
                            udid,
                            res.data.customerID,
                            false,
                            userModel.CreateUserForGuest,
                            savedUdid
                          );
                        });
                      });
                    }else
                    {
                      this.navigateSuccess(
                        udid,
                        guestUserId,
                        true,
                        userModel.CreateUserForGuest,
                        savedUdid
                      );
                    }

                  }
                }, 1000);
              } else {
                this.proccessing = false;
                this.paymentSucceeded = false;
                this.error = res.data.Status.Message;
              }
            })
            .catch(() => {
              this.proccessing = false;
              this.showPaymentIndicator = true;
              this.paymentSucceeded = false;
              this.error = "Network Error ...!";
            });
        }
      } catch {
        this.proccessing = false;
        this.showPaymentIndicator = true;
        this.paymentSucceeded = false;
        this.error = "Network Error ...!";
        this.scrollToPaymentIndicator();
      }

      if (is3ds) {
        let sRes = await stripePay.payByCard(orderObj);
        if (sRes.success == false) {
          this.error = sRes.message;
          this.proccessing = false;
          this.paymentSucceeded = false;
          return;
        }
        this.clearBeforeunload();
        if (res.data.Success === true) {
          if (this.unsubscribe) this.unsubscribe();
          this.paymentSucceeded = true;
          this.proccessing = false;

          setTimeout(async () => {
            this.showPaymentIndicator = false;
            this.SaveCoockie(orderObj);

            this.storeCartInStorage();
            const { table } = this.getSharedCartProps;
            await updateOrderStatus(table, this.storeid, { status: 'complete' });
            await removeOrder(this.storeid, table);
            this.clearCart();
            // reset user
            this.resetUser();
            this.RemoveCartItemsFromRepository({
              storeId: this.currentstore,
            });
            localStorage.removeItem("checkoutData");
            this.error = "";
            this.clearRoomAndTable();
            if (!userModel.IsGuest)
              this.navigateSuccess(
                udid,
                userModel.ID,
                false,
                userModel.CreateUserForGuest,
                savedUdid
              );
            else {
              if (userModel.IsGuest && userModel.CreateUserForGuest) {
                storeCard(res.data.customerID, cardModel).then(() => {
                  this.signUserIn({
                    email: userModel.Email,
                    password: guestUserId,
                  }).then(() => {
                    this.navigateSuccess(
                      udid,
                      res.data.customerID,
                      false,
                      userModel.CreateUserForGuest,
                      savedUdid
                    );
                  });
                });
              } else {
                this.navigateSuccess(
                  udid,
                  guestUserId,
                  true,
                  userModel.CreateUserForGuest,
                  savedUdid
                );
              }
            }
          }, 1000);
        } else {
          this.paymentSucceeded = false;
          this.error = res.data.Status.Message;
        }
      }



    },
    getOrderObject(savedUdid, savedGuestUserId) {
      let payment = new DefaultPaymentHandler();
      //
      let udid = savedUdid || this.orderIdentifier;
      let scheduledTime = this.isDelivery
        ? this.selectedDeliveryTime
        : this.selectedPickupTime;
      //generate token and save in db
      let userModel = this.createUserModel();
      this.add_user_checkout_info(userModel);
      userModel.CreateUserForGuest = this.registerNew && !this.userIsExist;
      userModel.JoinOurMail = this.JoinOurMail;
      let cardModel = this.createCardModel();
      let guestUserId = savedGuestUserId || this.guestUserIdentifier;

      if (!this.isChargeToRoom) {
        this.roomDeliveryModel.RoomNumber = "";
      }
      if (!this.isEatIn) {
        this.eatInModel.TableNumber = "";
      }
      let orderInfo = {
        subsidyFee: this.getSubsidyFee,
        orderType: this.orderType,
        notes: this.notes,
        // Do not set scheduledTime for pay later orders.
        scheduledTime: scheduledTime && !this.placingPayLaterOrder
          ? scheduledTime.toJSDate().toUTCString()
          : null,
        roomNumber: this.roomDeliveryModel.RoomNumber,
        tableNumber: this.eatInModel.TableNumber,
        securityCode: this.eatInModel.SecurityCode,
        DeliveryInstructions: this.isDelivery
          ? this.deliveryAddressModel.DeliveryInstructions
          : "",
        isPayLater: this.placingPayLaterOrder,
      };
      if (this.isDelivery) {
        orderInfo.OrderDeliveryTime = this.getDeliveryPureDuration;
        Object.defineProperty(orderInfo, "DeliveryAddress", {
          value: {
            Address: this.deliveryAddressModel.StreetAddress,
            Postcode: this.deliveryAddressModel.PostalCode,
            Suburb: this.deliveryAddressModel.CityTown,
            State: this.deliveryAddressModel.State,
            Longitude: this.deliveryAddressModel.Longitude,
            Latitude: this.deliveryAddressModel.Latitude,
          },
          enumerable: true,
        });
      }
      return payment.MakePaymentBody(
        udid,
        cardModel,
        userModel,
        this.selectedCompany,
        orderInfo,
        guestUserId,
        this.paymentMethod,
        false,
        this.used_coupons,
        {
          RewardPoints: this.getPoints,
          RedeemPoints: this.getRedemPoints,
        },
        savedUdid ? true : false,
        this.stripeToken
      );
    },
    clearRoomAndTable() {
      window.localStorage.removeItem("room");
      window.localStorage.removeItem("coupon");
    },
    googlePaymentError(err) {
      this.error = err;
    },
    async beginStripePayment(trackingOrder) {
      this.clearBeforeunload();
      this.storeCartInStorage();
      this.clearCart();
      this.RemoveCartItemsFromRepository({ storeId: this.currentstore });
      localStorage.removeItem("checkoutData");
      this.error = "";
      this.clearRoomAndTable();
      this.SaveCoockie(trackingOrder);
      if (trackingOrder.TrackingOrder.OnlineOrderUserIdentifier)
        this.navigateSuccess(
          trackingOrder.TrackingOrder.UDID,
          trackingOrder.TrackingOrder.OnlineOrderUserIdentifier,
          false,
          false,
          false
        );
      else {
        this.navigateSuccess(
          trackingOrder.TrackingOrder.UDID,
          trackingOrder.TrackingOrder.GuestUserIdentifier,
          true,
          trackingOrder.GuestUser && trackingOrder.GuestUser.CreateUserForGuest
        );
      }
    },

    SaveCoockie(trackingorder) {
      let savedordersData = localStorage.getItem(
        trackingorder.TrackingOrder.StoreID + "-OrdersDatas"
      );
      var ordersdata =
        savedordersData != null ? JSON.parse(savedordersData) : [];
      if (ordersdata.length > 3) ordersdata.shift();
      ordersdata.push(trackingorder.TrackingOrder);
      localStorage.setItem(
        trackingorder.TrackingOrder.StoreID + "-OrdersDatas",
        JSON.stringify(ordersdata)
      );
    },
    processSaveOrder() {
      let udid = uuid();
      if (!this.cartItems || this.cartItems.length == 0) {
        let udidSS = sessionStorage.getItem("saveorderUdid");
        if (!udidSS) this.error = "Error...Try again!";
        else this.generateQR(udidSS);
        return;
      }
      this.proccessing = true;
      let payment = new DefaultPaymentHandler();
      let scheduledTime = DateTime.fromFormat(new Date(), "h:mm a");
      let userModel = {
        IsGuest: this.user ? false : true,
        ID: this.user ? this.user.id : "",
        FirstName: this.dbuser ? this.dbuser.FirstName : "",
        LastName: this.dbuser ? this.dbuser.LastName : "",
        DisplayName: "",
        Phone: "",
        Email: this.user ? this.user.email : "",
      };
      userModel.CreateUserForGuest = this.registerNew && !this.userIsExist;
      userModel.JoinOurMail = this.JoinOurMail;
      let orderInfo = {
        orderType: 10,
        notes: "",
        scheduledTime: scheduledTime && !this.placingPayLaterOrder
          ? scheduledTime.toJSDate().toUTCString()
          : null,
        roomNumber: null,
        tableNumber: null,
      };
      let guestUserId = uuid();
      payment
        .MakePayment(
          udid,
          {},
          userModel,
          this.selectedCompany,
          orderInfo,
          guestUserId,
          this.paymentMethod,
          false,
          this.used_coupons,
          null,
          {},
          this.stripeToken
        )
        .then((res) => {
          this.proccessing = false;
          if (res.data.Success === true) {
            this.clearCart();
            this.RemoveCartItemsFromRepository({ storeId: this.currentstore });
            this.generateQR(udid);
          } else {
            this.error = res.data.Status.Message;
          }
        })
        .catch(() => {
          this.proccessing = false;
          this.error = "Network Error ...!";
        });
    },
    initModel() {
      //
      if (
        (!this.deliveryAddress ||
          !this.deliveryAddress.StreetAddress ||
          this.deliveryAddress.StreetAddress == "") &&
        this.userInfo &&
        this.userInfo.DeliveryAddress
      ) {
        this.deliveryAddressModel.StreetAddress =
          this.userInfo.DeliveryAddress.Address |
          this.deliveryAddressModel.StreetAddress;
        this.deliveryAddressModel.PostalCode =
          this.userInfo.DeliveryAddress.PostCode |
          this.deliveryAddressModel.PostalCode;
        this.deliveryAddressModel.CityTown =
          this.userInfo.DeliveryAddress.City |
          this.deliveryAddressModel.CityTown;
        this.deliveryAddressModel.State =
          this.userInfo.DeliveryAddress.State |
          this.deliveryAddressModel.State |
          "";
        this.deliveryAddressModel.Phone =
          this.userInfo.DeliveryAddress.Phone |
          this.deliveryAddressModel.Phone |
          "";
        this.deliveryAddressModel.DeliveryInstructions =
          this.userInfo.DeliveryAddress.DeliveryInstructions |
          this.deliveryAddressModel.DeliveryInstructions |
          "";
        this.deliveryAddressModel.Latitude =
          this.userInfo.DeliveryAddress.Latitude |
          this.deliveryAddressModel.Latitude |
          "";
        this.deliveryAddressModel.Longitude =
          this.userInfo.DeliveryAddress.Longitude |
          this.deliveryAddressModel.Longitude |
          "";
        this.applyDeliveryAddress({
          address: {
            ...this.deliveryAddressModel,
          },
          scheduledTime: this.selectedDeliveryTime
            ? new Date(this.selectedDeliveryTime).toISOString()
            : null,
          isUpdateDeliverAddress: true,
        });
      } else {
        this.deliveryAddressModel = {
          ...this.deliveryAddress,
        };
        if (this.userInfo && this.userInfo.DeliveryAddress) {
          this.deliveryAddressModel.DeliveryInstructions =
            this.userInfo.DeliveryAddress.DeliveryInstructions || "";
        }
      }

      if (this.userCheckoutInfo) {
        this.detailModel.FirstName = this.roomDeliveryModel.FirstName = this.eatInModel.FirstName = this.userCheckoutInfo.FirstName;
        this.detailModel.LastName = this.roomDeliveryModel.LastName = this.eatInModel.LastName = this.userCheckoutInfo.LastName;
        this.detailModel.Email = this.roomDeliveryModel.Email = this.eatInModel.Email = this.userCheckoutInfo.Email;
        this.detailModel.Phone = this.eatInModel.PhoneNumber = this.userCheckoutInfo.Phone;
      }

      if (this.userInfo && this.userInfo.FirstName) {
        this.detailModel.FirstName = this.roomDeliveryModel.FirstName = this.eatInModel.FirstName = this.userInfo.FirstName;
        this.detailModel.LastName = this.roomDeliveryModel.LastName = this.eatInModel.LastName = this.userInfo.LastName;
        this.detailModel.Email = this.roomDeliveryModel.Email = this.eatInModel.Email = this.userInfo.Email;
        this.detailModel.Phone = this.eatInModel.PhoneNumber = this.userInfo.Mobile;
      }
    },
    async setPickupDeliveryDates(initialDate) {
      var date = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      let cutOffDays = (this.selectedCompany.PreOrderCutOffDays || 0); // plus today
      let cutOffTime = DateTime.fromFormat(
        date.toFormat("dd MMMM yyyy") +
        " " +
        (this.selectedCompany.PreOrderCutOffTime || "00:00"),
        "dd MMMM yyyy hh:mm",
        { zone: date.zone }
      );

      if (date > cutOffTime && cutOffDays > 0) {
        cutOffDays++;
      }
      // cutOffDays = cutOffDays > 0 ? cutOffDays + 1 : cutOffDays;
      this.deliveryDisabledDates = availablePickupDeliveryDates(
        this.selectedCompany.BlackoutDates,
        this.getOrderPreparationTime,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation ||
        this.selectedCompany.EnablePreoderForDelivery,
        date,
        this.selectedCompany.NumberOfDaysInAdvanceForDelivery,
        this.selectedCompany.PreOrderCutOffDays
          ? (this.selectedCompany.PreOrderCutOffDays || 0) // plus today
          : this.selectedCompany.PreOrderCutOffDays || 0,
        this.selectedCompany.PreOrderCutOffTime,
        this.deliveryTimeSlots,
        this.isDeliveryTimeSlotsEnable
      );

      this.pickupDisabledDates = availablePickupDeliveryDates(
        this.selectedCompany.BlackoutDates,
        this.getOrderPreparationTime,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation ||
        this.selectedCompany.EnablePreoderForPickup,
        date,
        this.selectedCompany.NumberOfDaysInAdvanceForPickup
      );
      if (initialDate &&
        this.pickupDisabledDates.customPredictor(new Date(initialDate)) != true
      ) {
        this.deliveryDate = this.pickupDate = new Date(initialDate);
      } else {
      var startDate = date;
      var prePreprationTime = this.getOrderPreparationTime || 0;
      var nextOpenDay = getNexOpenDate(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        date.plus({
          minutes: prePreprationTime,
        }),
        true,
        this.deliveryTimeSlots,
        this.isDeliveryTimeSlotsEnable
      );

      if (nextOpenDay) {
        if (nextOpenDay.day != date.day) {

          if (cutOffDays > 0 && this.selectedCompany.PreOrderCutOffTime) {
            startDate = getNexOpenDate(
              this.selectedCompany.BlackoutDates,
              this.selectedCompany.OperatingHours,
              date.plus({
                days: cutOffDays,
              }),
              false,
              this.deliveryTimeSlots,
              this.isDeliveryTimeSlotsEnable
            );
          } else {
            startDate = getNexOpenDate(
              this.selectedCompany.BlackoutDates,
              this.selectedCompany.OperatingHours,
              date.plus({
                minutes:
                  prePreprationTime +
                  (this.selectedCompany.DeliveryTimeInterval || 0),
              }),
              true,
              this.deliveryTimeSlots,
              this.isDeliveryTimeSlotsEnable
            );
          }
        } else {
          if (cutOffDays > 0 && this.selectedCompany.PreOrderCutOffTime) {
            startDate = getNexOpenDate(
              this.selectedCompany.BlackoutDates,
              this.selectedCompany.OperatingHours,
              date.plus({
                minutes: prePreprationTime,
                days:cutOffDays
              }),
              true,
              this.deliveryTimeSlots,
              this.isDeliveryTimeSlotsEnable
            );
          }else
          {
            startDate = getNexOpenDate(
              this.selectedCompany.BlackoutDates,
              this.selectedCompany.OperatingHours,
              date.plus({
                minutes: prePreprationTime,
              }),
              true,
              this.deliveryTimeSlots,
              this.isDeliveryTimeSlotsEnable
            );
          }

        }
      }

      this.deliveryDate = startDate ? startDate.toJSDate() : null;

      startDate = getNexOpenDate(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        date.plus({
          minutes: prePreprationTime,
        })
      );
      this.pickupDate = this.startdate = startDate
        ? startDate.toJSDate()
        : null;
      }
      await this.setDeliveryTimes(this.deliveryDate, false, false, initialDate);
    },
    updatePostalCodeHandler() {
      setTimeout(() => {
        this.setPickupDeliveryDates(this.deliveryDate);
      }, 10);
    },
    async deliveryDateChanged(date) {
      await this.selectedDeliveryTimeChange(date);
      this.setDeliveryTimes(date, true, false, this.selectedDeliveryTime);
    },
    async setDeliveryTimes(date, forceUpdate = false, recursive = false,
      initialDate = null) {
      if (this.isUpdateDeliverAddress || forceUpdate) {
        var dpDate = new Date(DateTime.local().ts);
        if (this.deliveryDate != date) {
          this.deliveryDate = date;
        }
        dpDate = this.deliveryDate;
        this.dtimes = initPickupDeliveryTimes(
          this.selectedCompany.BlackoutDates,
          this.selectedCompany.OperatingHours,
          this.getOrderPreparationTime,
          dpDate,
          getCurrentDate(this.selectedCompany.TimezoneIanaFormat),
          this.getDeliveryDuration,
          true,
          this.selectedCompany.DeliveryTimeInterval,
          this.deliveryTimeSlots,
          this.isDeliveryTimeSlotsEnable,
          this.isPreOrder ? this.selectedCompany.PreOrderCutOffTime : null
        );
        if (this.dtimes.length > 0) {
          if (initialDate && this.getDeliveryDuration) {
            //let slotRange = parseInt(this.getDeliveryDuration.toFormat("m"));
            let mid = DateTime.fromJSDate(new Date(initialDate)).minus({
              minutes: 10, //temp solution max overlap(min interval)
            });
            var timeslot = this.dtimes.find(
              (p) => p.from <= mid && p.to >= mid
            );
            if (timeslot) this.selectedDeliveryTime = timeslot.time;
            else this.selectedDeliveryTime = this.dtimes[0].time;
          } else {
            this.selectedDeliveryTime = this.dtimes[0].time;
          }
          this.selectedDeliveryTimeChange();
        } else if (
          !recursive &&
          this.selectedCompany.EnablePreoderForDelivery
        ) {
          var currentDate = getCurrentDate(
            this.selectedCompany.TimezoneIanaFormat
          );
          var startDate = currentDate;
          startDate = getNexOpenDate(
            this.selectedCompany.BlackoutDates,
            this.selectedCompany.OperatingHours,
            currentDate.plus({
              days: 1,
            }),
            false,
            this.deliveryTimeSlots,
            this.isDeliveryTimeSlotsEnable
          );
          this.deliveryDate = startDate ? startDate.toJSDate() : null;
          await this.setDeliveryTimes(this.deliveryDate, forceUpdate, true, initialDate);
          return;
        } else {
          this.selectedDeliveryTime = null;
        }

        if (!this.isMobile() && this.$refs.shoppingCart)
          this.$refs.shoppingCart.SelecteDPTime(this.selectedDeliveryTime);
        if (this.dtimes.length == 0) {
          this.setScheduledDeliveryTime(null);
        } else {
          this.setScheduledDeliveryTime(
            new Date(this.selectedDeliveryTime).toISOString()
          );
        }
      }
    },
    setPickupTimes(date, recursive = false) {
      var dpDate = new Date(DateTime.local().ts);
      if (this.pickupDate != date) {
        this.pickupDate = date;
      }
      dpDate = this.pickupDate;
      this.pickupTimes = initPickupDeliveryTimes(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        this.getOrderPreparationTime,
        dpDate,
        getCurrentDate(this.selectedCompany.TimezoneIanaFormat),
        0,
        false,
        this.selectedCompany.PickupTimeInterval
      );
      if (this.pickupTimes.length > 0) {
        if (this.pickupTimes[0]) {
          this.selectedPickupTime = this.pickupTimes[0].time;
        } else {
          this.selectedPickupTime = null;
        }
      } else if (!recursive && this.selectedCompany.EnablePreoderForPickup) {
        var currentDate = getCurrentDate(
          this.selectedCompany.TimezoneIanaFormat
        );
        var startDate = currentDate;
        startDate = getNexOpenDate(
          this.selectedCompany.BlackoutDates,
          this.selectedCompany.OperatingHours,
          currentDate.plus({
            days: 1,
          }),
          true,
          null,
          false
        );
        this.pickupDate = startDate ? startDate.toJSDate() : null;
        if (this.pickupDate) this.setPickupTimes(this.pickupDate, true, this.initialDate);
        return;
      }

      if (!this.isMobile() && this.$refs.shoppingCart)
        this.$refs.shoppingCart.SelecteDPTime(this.selectedPickupTime);
    },
    navigateSuccess(udid, userid, isguest, CreateUserForGuest) {
      if (
        (this.viewConfig.LogIn === false || !this.user) &&
        this.viewConfig.HideTrackingOrderForGuest
      ) {
        this.$router.push({
          name: "thankyou",
          params: {
            storeid: this.storeid,
            storename: this.$route.params.storename,
            isGift: false,
          },
        });
      } else {
        this.$router.push({
          name: "completeorder",
          params: {
            storeid: this.storeid,
            orderid: udid,
            userid: userid,
            createUserForGuest: CreateUserForGuest,
            selectedCompanyId: this.selectedCompany.ID,
          },
        });
      }
    },
    computeRules() {
      if (this.selectedCompany) {
        if (this.getSelectedMenuType) {
          switch (this.getSelectedMenuType) {
            case CONSTANT_ORDER_TYPE_DELIVERY:
              this.deliveryMode();
              break;
            case CONSTANT_ORDER_TYPE_PICKUP:
              this.pickupMode();
              break;
            case CONSTANT_ORDER_TYPE_DINEIN:
              this.eatInMode();
              break;
          }
        }else{
          let table = sessionStorage.getItem("table");
          if (this.isEnableTab("dineIn") && table) {
            this.eatInMode();
          } else if (
            this.isEnableTab("delivery") &&
            (this.getIsDelivery ||
              !this.isEnableTab("pickUp") ||
              this.getIsDelivery == null)
          ) {
            this.deliveryMode();
          } else if (this.isEnableTab("pickUp")) {
            this.pickupMode();
          } else if (this.isEnableTab("deliverToRoom")) {
            this.chargeToRoomMode();
          } else if (this.isEnableTab("dineIn")) {
            this.eatInMode();
          }
          //if nothing is selected
          if (
            !(
              this.isDelivery ||
              this.isPickup ||
              this.isChargeToRoom ||
              this.isEatIn
            )
          ) {
            if (!this.selectedCompanyViewConfig.Delivery) this.deliveryMode();
            else if (!this.selectedCompanyViewConfig.PickUp) this.pickupMode();
            else if (!this.selectedCompanyViewConfig.DeliverToRoom)
              this.chargeToRoomMode();
            else this.eatInMode();
          }
        }

      } else {
        this.deliveryMode();
      }
    },
    setUserIsExist(value) {
      this.userIsExist = value;
    },
    createUserModel() {
      var userID = "";
      var firstName = "";
      var lastName = "";
      var displayName = "";
      var phone = "";
      var email = "";
      var dineInField = "";
      var isguest = true;
      if (this.user) {
        isguest = false;
        userID = this.user.id;
      }
      firstName =
        firstName ||
        this.detailModel.FirstName ||
        this.roomDeliveryModel.FirstName ||
        this.eatInModel.FirstName ||
        "";
      lastName =
        lastName ||
        this.detailModel.LastName ||
        this.roomDeliveryModel.LastName ||
        this.eatInModel.LastName ||
        "";
      email =
        email ||
        this.detailModel.Email ||
        this.roomDeliveryModel.Email ||
        this.eatInModel.Email ||
        "";
      dineInField =
        dineInField ||
        this.eatInModel.DineInField ||
        "";
      phone =
        this.detailModel.Phone ||
        this.eatInModel.PhoneNumber ||
        "";
      displayName = firstName + " " + lastName;
      return {
        IsGuest: isguest,
        ID: userID,
        FirstName: firstName.trim(),
        LastName: lastName.trim(),
        DisplayName: displayName.trim(),
        Phone: phone.trim(),
        Email: email.trim(),
        DineInField: dineInField.trim(),
      };
    },
    createCardModel() {
      if (this.paymentMethod == 8) {
        return null;
      }

      let exDate = this.paymentModel.ExpireDate.split("/");
      let isToken = false;
      if (this.paymentModel.SelectedCard) {
        isToken = true;
      }
      let useCard = !isToken && this.paymentMethod == 1;
      return {
        exclude: !useCard,
        isToken: isToken,
        token: isToken ? this.paymentModel.SelectedCard.CardIdentifier : "",
        cvc: this.paymentModel.CVV,
        expMonth: exDate[0],
        expYear: useCard ? "20" + exDate[1] : "",
        number: this.paymentModel.CardNumber,
        holder: this.paymentModel.CardHolder.trim(),
      };
    },
    clearAllOrders() {
      this.cartItems.forEach((cartitem) => {
        this.REMOVE_CART_ITEM({
          item: cartitem,
        });
        this.applyPriceTriggers();
      });
    },
    syncFirstName(firstName) {
      this.detailModel.FirstName = firstName;
      this.roomDeliveryModel.FirstName = firstName;
      this.eatInModel.FirstName = firstName;
    },
    checkGoogleLoaded() {
      var that = this;
      var interval = setInterval(() => {
        try {
          if (google && google.maps) {
            that.googleLoaded = true;
            clearInterval(interval);
          }
        } catch {
          that.googleLoaded = false;
        }
      }, 500);
    },
    isEnableTab(tabName) {
      var now = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      var storeOpen = IsStoreOpenAtTime(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation,
        now
      );
      var result;
      switch (tabName) {
        case "delivery":
          if (!this.selectedCompany.EnablePreoderForDelivery) {
            now = now.plus({
              minutes: this.selectedCompany.OrderPreparationTime,
            });
            storeOpen = IsStoreOpenAtTime(
              this.selectedCompany.BlackoutDates,
              this.selectedCompany.OperatingHours,
              this.selectedCompany.IsInOperation,
              now
            );
          }
          result =
            this.selectedCompanyViewConfig.Delivery &&
            (storeOpen || this.selectedCompany.EnablePreoderForDelivery) &&
            !sessionStorage.getItem("hideOtherOrderType");

          if (!result && this.isDelivery) {
            if (this.isEnableTab("pickUp")) this.pickupMode();
            else if (this.isEnableTab("dineIn")) this.eatInMode();
            else if (this.isEnableTab("deliverToRoom")) this.chargeToRoomMode();
          }
          return result;
        case "pickUp":
          if (!this.selectedCompany.EnablePreoderForPickup) {
            now = now.plus({
              minutes: this.selectedCompany.OrderPreparationTime,
            });
            storeOpen = IsStoreOpenAtTime(
              this.selectedCompany.BlackoutDates,
              this.selectedCompany.OperatingHours,
              this.selectedCompany.IsInOperation,
              now
            );
          }
          result =
            this.selectedCompanyViewConfig.PickUp &&
            (storeOpen || this.selectedCompany.EnablePreoderForPickup) &&
            !this.pickupDisabled &&
            !sessionStorage.getItem("hideOtherOrderType");
          if (!result && this.isPickup) {
            if (this.isEnableTab("delivery")) this.deliveryMode();
            else if (this.isEnableTab("dineIn")) this.eatInMode();
            else if (this.isEnableTab("deliverToRoom")) this.chargeToRoomMode;
          }
          return result;
        case "deliverToRoom":
          now = now.plus({
            minutes: this.selectedCompany.OrderPreparationTime,
          });
          storeOpen = IsStoreOpenAtTime(
            this.selectedCompany.BlackoutDates,
            this.selectedCompany.OperatingHours,
            this.selectedCompany.IsInOperation,
            now
          );
          result =
            this.selectedCompanyViewConfig.DeliverToRoom &&
            !this.deliveryDisabled &&
            storeOpen &&
            !sessionStorage.getItem("hideOtherOrderType");
          if (!result && this.isChargeToRoom) {
            if (this.isEnableTab("pickUp")) this.pickupMode();
            else if (this.isEnableTab("delivery")) this.deliveryMode();
            else if (this.isEnableTab("dineIn")) this.eatInMode();
          }
          return result;
        case "dineIn":
          now = now.plus({
            minutes: this.selectedCompany.OrderPreparationTime,
          });
          storeOpen = IsStoreOpenAtTime(
            this.selectedCompany.BlackoutDates,
            this.selectedCompany.OperatingHours,
            this.selectedCompany.IsInOperation,
            now
          );
          result =
            this.selectedCompanyViewConfig.EatIn &&
            storeOpen || sessionStorage.getItem("table");
          if (!result && this.isEatIn) {
            if (this.isEnableTab("pickUp")) this.pickupMode();
            else if (this.isEnableTab("delivery")) this.deliveryMode();
            else if (this.isEnableTab("deliverToRoom")) this.chargeToRoomMode();
          }
          return result;
        default:
          return false;
      }
    },
    confirmToClose(event) {
      var confimationMessage = `We are in the middle of sending your order`;
      (event || window.event).returnValue = confimationMessage;
      return confimationMessage;
    },
    setBeforeunload() {
      window.addEventListener("beforeunload", this.confirmToClose, false);
    },
    clearBeforeunload() {
      window.removeEventListener("beforeunload", this.confirmToClose, false);
    },
    selectedDeliveryTimeChange() {
      if (
        this.selectedCompany.EnableThirdPartyDelivery &&
        this.selectedCompany.EnableThirdPartyDelivery.DoorDash
      ) {
        this.applyDeliveryAddress({
          address: {
            ...this.deliveryAddressModel,
          },
          scheduledTime: new Date(this.selectedDeliveryTime).toISOString(),
          isUpdateDeliverAddress: false,
        });
      }
    },
    getTimeSlotStyle(isSelected) {
      var styles = [];
      if (isSelected) {
        styles.push({
          "background-color": "#172C56",
        });
        styles.push({
          color: "#ffffff",
        });
      }
      return styles;
    },
    StoreCard(cardModel) {
      storeCard(this.user.id, cardModel, this.storeid);
    },

    togglePayLaterPopup() {
      this.payLaterPopup = !this.payLaterPopup;
    },
    payLaterButtonClicked() {
      this.payLaterButtonPressed = true
      if(this.currentStoreDoc.PayLaterPopupEnabled) {
        this.togglePayLaterPopup();
      } else {
        this.payLaterClickHandler();
      }

    },
  },
  handleScroll() {
    const value = window.scrollY;
    if (value != 0) {
      this.$data.windowScrollY = value;
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  beforeDestroy(that) {
    if (that.unsubscribe) {
      that.unsubscribe();
    }
  }
};
